import React, { Component } from "react";
import "./App.css";
import Info from "./Info";
import Spotify from "./Spotify";
import cover from "./img/cover.png";
import Mujy from "./Mujy";
var SpotifyWebApi = require("spotify-web-api-node");

export class App extends Component {
  state = {
    name: "Sanatçı",
    track: "Şarkı Adı",
    image: cover,
    color: "#000",
    searchTrack: [],
    token: "",
  };

  setAlbum = (e) => {
    if (e.hex) {
      this.setState({ color: e.hex });
    } else if (e.target.name === "image") {
      this.setState({
        [e.target.name]: URL.createObjectURL(e.target.files[0]),
      });
    } else {
      this.setState({ [e.target.name]: e.target.value });
    }
  };

  getspotify = (e) => {
    this.setState({ searchTrack: [] });

    if (e.target.value) {
      var spotifyApi = new SpotifyWebApi({
        clientId: process.env.REACT_APP_CLIENTID,
        clientSecret: process.env.REACT_APP_CLIENtSECRET,
        redirectUri: "http://localhost:3000/",
      });

      spotifyApi.setAccessToken(
        this.state.token
      );
      spotifyApi.searchTracks(e.target.value).then((data) => {
        this.setState({
          searchTrack: [...this.state.searchTrack, data.body.tracks.items],
        });
      });
    }
  };

  setSearch = (key) => {
    this.setState({ track: this.state.searchTrack[0][key].name });
    this.setState({ name: this.state.searchTrack[0][key].artists[0].name });
    this.setState({
      image: this.state.searchTrack[0][key].album.images[0].url,
    });
    this.setState({ searchTrack: [] });
  };

  setToken = () => {


    var client_id= "6e2d60887d9149d38c0fc85041bd71bd"; // Your client id
    var client_secret ="424c774e92584c2ba9ff338d7b40456e"; // Your secret
 

    fetch('https://accounts.spotify.com/api/token', {
      method: 'POST',
      headers: {
        Authorization:
        "Basic " +
        new Buffer(client_id + ":" + client_secret).toString("base64"),
    
        'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
      },
      body: 'grant_type=client_credentials'
  })
  .then(response => response.json())
  .then(data => {
      this.setState({token:data.access_token})
  });



    
 


  };
  componentDidMount() {
    const script1 = document.createElement("script");
    script1.src =
      "https://cdnjs.cloudflare.com/ajax/libs/jquery/3.5.1/jquery.min.js";
    script1.async = true;

    const script2 = document.createElement("script");
    script2.src =
      "https://cdnjs.cloudflare.com/ajax/libs/gsap/3.5.1/gsap.min.js";
    script2.async = true;

    const script3 = document.createElement("script");
    script3.src =
      "https://cdnjs.cloudflare.com/ajax/libs/twitter-bootstrap/4.5.3/js/bootstrap.min.js";
    script3.async = true;

    const script4 = document.createElement("script");
    script4.src = "https://s3.eu-central-1.amazonaws.com/shopier/framework.js";
    script4.async = true;

    document.body.appendChild(script1);
    document.body.appendChild(script2);
    document.body.appendChild(script3);
    document.body.appendChild(script4);

this.setToken();
  }

  scriptLoaded() {
    window.A.sort();
  }

  render() {
    return (
      <div className="Focus">
        <Mujy />
        <div className="Content" id="create">
          <div className="info">
            <div>
              <Info
                setAlbum={this.setAlbum}
                getspotify={this.getspotify}
                search={this.state.searchTrack}
                setSearch={this.setSearch}
              />

              <ul>
                <li></li>
              </ul>
            </div>
          </div>
          <Spotify state={this.state} />
        </div>
        <div className="btn">
          <button className="shopier btn-shopier" id="7402873">
            Hemen Satın Al
          </button>
        </div>
      </div>
    );
  }
}

export default App;
